<template>
  <div>
    <AnswerField
      v-for="subfieldtype in fieldType.subfieldtypes"
      :key="subfieldtype.id"
      :userFormId="userFormId"
      :question="question"
      :fieldType="subfieldtype"
    />
  </div>
</template>

<script>
import AnswerField from './AnswerField'

export default {
  name: 'CustomFieldType',
  props: ['userFormId', 'question', 'fieldType'],
  components: {
    AnswerField
  }
}
</script>
